{
	"backLinkTitle": "Back to Manage declarations",
	"invoicedQuantity": "Invoiced quantity",
	"remainingForDeclarationCreation": "Remaining for declaration creation",
	"nonTransferableAmount": "Non-allocatable amount",
	"btnCreateDeclaration": "+ Create declaration",
	"errorMessage": "Failed to load material details"
}
